import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=3b988a1e&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=js&"
export * from "./Error404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b988a1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b988a1e')) {
      api.createRecord('3b988a1e', component.options)
    } else {
      api.reload('3b988a1e', component.options)
    }
    module.hot.accept("./Error404.vue?vue&type=template&id=3b988a1e&scoped=true&", function () {
      api.rerender('3b988a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/ErrorPages/Error404.vue"
export default component.exports